/* Netpeak P24/P25 (23.09.2026) — karta „Podpiętka z materiału EVA”.
   1) Kolory z konfiguratora dywaników (evmNpMatColors, skopiowane w evm-np-heelpad.liquid) ustawia w formularzu
      podpiętki, jeśli klient jeszcze nic tu nie zmienił, i pokazuje je w trzeciej linii „Pasuje…”.
   2) Schemat M / XL podświetla rozmiar wybrany w polu „Rozmiar”. */
(function () {
  'use strict';
  var userTouched = false;
  document.addEventListener('change', function (e) { if (e.isTrusted) userTouched = true; }, true);

  function readColors() {
    try { return JSON.parse(sessionStorage.getItem('evmNpMatColors') || 'null'); } catch (e) { return null; }
  }
  function applyColors() {
    var d = readColors();
    if (!d || !d.matColor) return;
    var root = document.querySelector('.product.config_container') || document;
    var map = [['matColor', 'properties[Kolor materialu]'], ['trimColor', 'properties[Kolor obszycia]'], ['matPattern', 'properties[Ksztalt komorek]']];
    /* klient już konfigurował tę podpiętkę w tej karcie — jego wybór (przywracany przez persist) ma pierwszeństwo */
    if (!userTouched && !window.__evmNpOwnCfg) {
      map.forEach(function (m) {
        var f = d[m[0]];
        if (!f || !f.dataValue) return;
        var inp = root.querySelector('input[type="radio"][name="' + m[1] + '"][data-value="' + String(f.dataValue).replace(/"/g, '') + '"]');
        if (inp && !inp.checked) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    var li = document.querySelector('[data-evm-np-hp-color] span');
    var ul = document.querySelector('[data-evm-np-hp-fit]');
    if (li && d.matColor.value) {
      var en = ul && ul.getAttribute('data-en') === '1';
      var txt = (en ? 'Colours as in your set: ' : 'Kolory jak w Twoim komplecie: ') + d.matColor.value + (d.trimColor && d.trimColor.value ? ' / ' + d.trimColor.value : '');
      li.textContent = txt;
      li.parentNode.classList.add('is-matched');
    }
  }

  function syncSize() {
    var fig = document.querySelector('[data-evm-np-hp-size]');
    if (!fig) return;
    var inp = document.querySelector('fieldset[data-name="mats_size"] input[type="radio"]:checked');
    var v = inp ? String(inp.value || '').trim().toUpperCase() : '';
    var sel = v === 'XL' ? 'XL' : (v === 'M' ? 'M' : '');
    fig.setAttribute('data-selected', sel);
    /* plakietka w nagłówku sekcji „Rozmiar”, jak „ROMBY” przy „Kształt komórek” */
    var pill = fig.querySelector('[data-evm-np-hp-size-value]');
    if (pill) { pill.textContent = sel; pill.hidden = !sel; }
    Array.prototype.forEach.call(fig.querySelectorAll('.evm-np-hp-size__row'), function (row) {
      var on = row.getAttribute('data-size') === sel;
      row.setAttribute('aria-checked', on ? 'true' : 'false');
      row.tabIndex = on || !sel ? 0 : -1;
    });
  }

  /* 24.09: rozmiar wybiera się w samej tabeli; pole „Rozmiar” formularza zostaje (to ono trafia do koszyka),
     tylko ukryte — i tylko gdy ten skrypt działa, więc bez JS zostają zwykłe przyciski M / XL. */
  function bindTable() {
    var fig = document.querySelector('[data-evm-np-hp-size]');
    var fs = document.querySelector('fieldset[data-name="mats_size"]');
    if (!fig || !fs) return;
    fs.classList.add('evm-np-hp-fs-hidden');
    fs.setAttribute('aria-hidden', 'true');
    Array.prototype.forEach.call(fs.querySelectorAll('input, label'), function (el) { el.setAttribute('tabindex', '-1'); });
    var rows = Array.prototype.slice.call(fig.querySelectorAll('.evm-np-hp-size__row'));
    function pick(row) {
      var v = row.getAttribute('data-size');
      var inp = Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return String(i.value || '').trim().toUpperCase() === v; });
      if (inp && !inp.checked) {
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncSize();
    }
    rows.forEach(function (row, i) {
      row.addEventListener('click', function () { pick(row); });
      row.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : ((e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0);
        if (!d) return;
        e.preventDefault();
        var next = rows[(i + d + rows.length) % rows.length];
        pick(next);
        next.focus();
      });
    });
  }

  function boot() {
    bindTable();
    syncSize();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('fieldset[data-name="mats_size"]')) syncSize();
    });
    /* po inicjalizacji konfiguratora (product-config.js, persist z opóźnieniem 280 ms) */
    window.addEventListener('load', function () { setTimeout(function () { applyColors(); syncSize(); }, 700); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
